import { render, staticRenderFns } from "./EspecificacionValidaciones.vue?vue&type=template&id=2f696808&"
import script from "./EspecificacionValidaciones.vue?vue&type=script&lang=js&"
export * from "./EspecificacionValidaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports